import KeenSlider from 'keen-slider';

class ProductSyllabus extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.productSyllabus = this.querySelector('.product-syllabus');
    this.slides = [...this.querySelectorAll('.syllabus-slide')];
    this.prevButton = this.querySelector('.prev-button');
    this.nextButton = this.querySelector('.next-button');
    this.dots = [...this.querySelectorAll('.dot')];
    let interval = 0;

    let animation = { duration: 1000, easing: (t) => t };
    let slider = new KeenSlider(this.productSyllabus, {
      slides: {
        perView: 1.2,
        spacing: 21,
        origin: 0,
      },
      dragStart: () => {
        autoplay(false);
      },
      dragEnd: () => {
        autoplay(true);
      },
      created: (instance) => {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', function () {
            instance.moveToIdx(index);
          });
        });
        this.prevButton.addEventListener('click', () => {
          instance.prev();
        });

        this.nextButton.addEventListener('click', () => {
          instance.next();
        });
      },
      // updated: (instance) => {
      //   instance.moveToIdx(s.track.details.abs + 2, true, animation);
      // },
      slideChanged: (instance) => {
        let slideNum = instance.track.details.rel;
        this.slides.forEach((slide, index) => {
          if (index === slideNum) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });
        this.dots.forEach((dot, index) => {
          if (index === slideNum) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      },
    });

    function autoplay(run) {
      clearInterval(interval);
      interval = setInterval(() => {
        if (run && slider) {
          // slider.next()
          slider.moveToIdx(slider.track.details.abs + 1, true, animation);
        }
      }, 7000);
    }

    this.productSyllabus.addEventListener('mouseover', () => {
      autoplay(false);
    });

    this.productSyllabus.addEventListener('mouseout', () => {
      autoplay(true);
    });

    autoplay(true);

    console.log('syllabus slider');
    console.log(slider);
  }
}

if (!customElements.get('product-syllabus'))
  customElements.define('product-syllabus', ProductSyllabus);
